import { unwrap } from "@majourneys/api-client";
import { api } from "../../../lib/api";

export type AccountProfile = {
  user: {
    id: string;
    email: string;
    firstName: string | null;
    lastName: string | null;
    name: string;
    avatar: string | null;
    emailVerified: boolean;
    /** "+212612345678", or null when the account has none. */
    phone?: string | null;
  };
  preferences: {
    location: string;
    currency: string;
    language: string;
  };
};

export const profileApi = {
  getMine: async (): Promise<AccountProfile> => unwrap(await api.me.get()),
  updatePreferences: async (input: AccountProfile["preferences"]): Promise<void> => {
    unwrap(await api.me.preferences.post(input));
  },
  /**
   * PATCH /me/profile, the same call the account's Traveler details cards
   * make. Sending only `firstName` keeps the stored last name, and the API
   * rebuilds `users.name` from the two.
   */
  updateNames: async (input: { firstName?: string; lastName?: string }): Promise<void> => {
    const res = (await (
      api as unknown as { me: { profile: { patch: (b: object) => Promise<{ error?: unknown }> } } }
    ).me.profile.patch(input)) as { error?: unknown } | undefined;
    if (res?.error) throw new Error("profile update failed");
  },
};
